define("calendar/templates/media", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::MediaItemModal
    @account={{this.currentAccount}}
    @altTextCount={{this.altTextCount}}
    @canCreatePost={{this.canCreatePost}}
    @cancelEditingAltText={{this.cancelEditingAltText}}
    @cancelEditingCaption={{this.cancelEditingCaption}}
    @close={{perform this.canClose}}
    @createPostText={{this.createPostText}}
    @editAltText={{this.editAltText}}
    @editCaption={{this.editCaption}}
    @editPost={{this.editPost}}
    @editingAltText={{this.editingAltText}}
    @editingCaption={{this.editingCaption}}
    @hasDirtyAttributes={{this.hasDirtyAttributes}}
    @hasLabels={{this.hasLabels}}
    @hasSecondary={{this.hasSecondary}}
    @isMediaEditRouteExternal={{true}}
    @location="clicked_side_library_button_by_calendar"
    @maxAltTextCount={{this.maxAltTextCount}}
    @mediaItem={{this.model}}
    @model={{this.model}}
    @postElementId={{this.uniqueId}}
    @rejectCreatePostReason={{this.rejectCreatePostReason}}
    @rollbackSavedCaption={{perform this.rollbackSavedCaption}}
    @route="cluster.schedule.calendar.media"
    @saveEditedAltText={{perform this.saveEditedAltText}}
    @saveEditedCaption={{perform this.saveEditedCaption}}
    @savedCaptionToEdit={{this.savedCaptionToEdit}}
    @setCaptionToEdit={{set this "savedCaptionToEdit"}}
    @showUpgradeButton={{this.showUpgradeButton}}
    @socialProfile={{this.socialProfile}}
    @toggleCaptionTemplate={{this.toggleCaptionTemplate}}
    @toggleSecondary={{this.toggleSecondary}}
    @toggleSmartHashtags={{this.toggleSmartHashtags}}
  />
  {{outlet}}
  */
  {
    "id": "3WZcJIt5",
    "block": "[[[8,[39,0],null,[[\"@account\",\"@altTextCount\",\"@canCreatePost\",\"@cancelEditingAltText\",\"@cancelEditingCaption\",\"@close\",\"@createPostText\",\"@editAltText\",\"@editCaption\",\"@editPost\",\"@editingAltText\",\"@editingCaption\",\"@hasDirtyAttributes\",\"@hasLabels\",\"@hasSecondary\",\"@isMediaEditRouteExternal\",\"@location\",\"@maxAltTextCount\",\"@mediaItem\",\"@model\",\"@postElementId\",\"@rejectCreatePostReason\",\"@rollbackSavedCaption\",\"@route\",\"@saveEditedAltText\",\"@saveEditedCaption\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@showUpgradeButton\",\"@socialProfile\",\"@toggleCaptionTemplate\",\"@toggleSecondary\",\"@toggleSmartHashtags\"],[[30,0,[\"currentAccount\"]],[30,0,[\"altTextCount\"]],[30,0,[\"canCreatePost\"]],[30,0,[\"cancelEditingAltText\"]],[30,0,[\"cancelEditingCaption\"]],[28,[37,1],[[30,0,[\"canClose\"]]],null],[30,0,[\"createPostText\"]],[30,0,[\"editAltText\"]],[30,0,[\"editCaption\"]],[30,0,[\"editPost\"]],[30,0,[\"editingAltText\"]],[30,0,[\"editingCaption\"]],[30,0,[\"hasDirtyAttributes\"]],[30,0,[\"hasLabels\"]],[30,0,[\"hasSecondary\"]],true,\"clicked_side_library_button_by_calendar\",[30,0,[\"maxAltTextCount\"]],[30,0,[\"model\"]],[30,0,[\"model\"]],[30,0,[\"uniqueId\"]],[30,0,[\"rejectCreatePostReason\"]],[28,[37,1],[[30,0,[\"rollbackSavedCaption\"]]],null],\"cluster.schedule.calendar.media\",[28,[37,1],[[30,0,[\"saveEditedAltText\"]]],null],[28,[37,1],[[30,0,[\"saveEditedCaption\"]]],null],[30,0,[\"savedCaptionToEdit\"]],[28,[37,2],[[30,0],\"savedCaptionToEdit\"],null],[30,0,[\"showUpgradeButton\"]],[30,0,[\"socialProfile\"]],[30,0,[\"toggleCaptionTemplate\"]],[30,0,[\"toggleSecondary\"]],[30,0,[\"toggleSmartHashtags\"]]]],null],[1,\"\\n\"],[46,[28,[37,4],null,null],null,null,null]],[],false,[\"shared/media-item-modal\",\"perform\",\"set\",\"component\",\"-outlet\"]]",
    "moduleName": "calendar/templates/media.hbs",
    "isStrictMode": false
  });
});